/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { useSelector, useDispatch } from 'react-redux';
import { InputText } from "primereact/inputtext";
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Checkbox } from "primereact/checkbox";
import { useLocation } from 'react-router-dom';
import { FaCircleMinus, FaCirclePlus } from "react-icons/fa6";
import MarkupViewer from '../../MarkupViewer';
import FileUploader from '../../FileUploader'
import MarkupChanger from '../../MarkupChanger';
import FormBuilder from '../../FormBuilder';
import LayoutChanger from '../../LayoutChanger';
import { setLPDetails } from '../../../slices/createLPSlice';
import './trendLineTemplate.css';
import { LandingPageServe } from '../../../services/api/LandingPageServ';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const TrendLineTemplate = () => {
  const toast = useRef(null);
  const lpDetails = useSelector((state) => state.createLp.data);
  const isEditable = useSelector((state) => state.auth.isEditable);
  const isLogged = useSelector((state) => state.auth.isLogged);
  const dispatch = useDispatch();
  const [url, setUrl] = useState('');
  const [editMode, setEditMode] = useState(isEditable);
  const [currentEditSection, setCurrentEditSection] = useState('');
  const [viewUploader, setViewUploader] = useState(false);
  const [viewEditor, setViewEditor] = useState(false);
  const [viewFormBuilder, setViewFormBuilder] = useState(false);
  const [viewLayoutChanger, setViewLayoutChanger] = useState(false)
  const [layout, setLayout] = useState(lpDetails.lplayout);
  const [templateNo , setTemplateNo] = useState(lpDetails.templateNo);
  const [content, setContent] = useState(null)
  const [markup, setMarkup] = useState('')
  const [emailLayout, setemailLayout] = useState(lpDetails.emaillayout);
  // const [isWebinar, setisWebinar] = useState(false);

  const getFormErrorMessage = (name) => {
    return errors[name] ? <small className="p-error"  style={{ display : "flex" , marginBottom : "20px"  }}>{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
  };




  const {
    formState: { errors },
    handleSubmit,
    control,
    reset
  } = useForm();

  const {
    fields: itemFields,
    append: appendItem,
    remove: removeItem
  } = useFieldArray({
    control,
    name: "Items"
  })

//  const [url, setUrl] = useState('');
  const location = useLocation();

  useEffect(() => {
    console.log(lpDetails)
    setUrl(location.pathname);
   
    if (isLogged) {
      setEditMode(isEditable)
     
    } else {
      setEditMode(false)
    }

    if (lpDetails._id) {
      setLayout(lpDetails.lplayout);
      setTemplateNo(lpDetails.templateNo);
      document.title =lpDetails['lplayout']['title']['text'];
    }
    if (lpDetails.fields.length > 0) {
      reset()
      for (const f of lpDetails.fields) {
        appendItem(f)
      }
    }
  }, [lpDetails])



  const dispatchLayout = (obj) => {
    dispatch(setLPDetails({ lplayout: { ...layout, ...obj , ...templateNo } }))
  }

   const dispatchEmailLayout=(obj) => {
      let footerObj = {}
      if(obj['headerLogo']){
        footerObj = {footerLogo:{ url: obj.headerLogo.url}}
        setLPDetails({emaillayout: {...emailLayout , ...footerObj}})
      } 
      dispatch(setLPDetails( { emaillayout: { ...emailLayout, ...obj , ...templateNo }}))
    }

  const dispatchFields = (data) => {
    dispatch(setLPDetails({ fields: [...itemFields, ...[data]] }))
  }

  const onFormSubmit = async (data) => {
    try {
      delete data['Items']
      if (!isEditable) {
        await LandingPageServe.saveform({ lpId: lpDetails._id, lead: data });
      }
      reset()
      toast.current.show({ severity: 'success', summary: 'Success', detail: 'Submitted successfully' });
      window.open(lpDetails.assetLink,"_self")
    } catch (error) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: error.message });

    }
  };

  const handleDragEnd = (result) => {
    if (!result.destination) {
        return;
    }

    const items = Array.from(itemFields);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    dispatch(setLPDetails({ fields: items }));
}; 

  const handleClick = (type) => {
    setCurrentEditSection(type)
    if (type === 'HEADER_LOGO' || type === 'HERO_IMAGE' || type === 'FOOTER_LOGO') {
      setViewUploader(true)
    }
    if (type === 'TITLE') {
      setContent(layout.title)
      setViewLayoutChanger(true)
    }
    if (type === 'FORM_TITLE') {
      setContent(layout.formTitle)
      setViewLayoutChanger(true)
    }

    if (type === 'HERO_CONTENT') {
      setMarkup(layout.heroContent)
      setViewEditor(true)
    }
    if (type === 'ACTION_BTN') {
      setContent(layout?.actionButton)
      setViewLayoutChanger(true)
    }
    if (type === 'FOOTER_CONTENT') {
      setMarkup(layout.footerContent);
      setViewEditor(true)
    }
    if(type === 'CONTENT_LOGO'){
      setContent(layout.contentLogoUrl)
      setViewUploader(true)
    }
    if(type === 'ADDITIONAL_TITLE'){
      setContent(layout.additionalTitle)
      setViewLayoutChanger(true)
    }
  };

  const handleAdd = () => {
    setViewFormBuilder(true)
  };

  const handleRemove = (i) => {
    removeItem(i)
    const updatedFields = lpDetails['fields'].filter((ele,e)=> ele['name'] !== lpDetails['fields'][i]['name']);
    dispatch(setLPDetails({ fields: [...updatedFields]}));
  };

  const handleCloseEditor = (data , isWebinar , duration , webinarTitle) => {
    
    let obj = {}
    if (currentEditSection === 'HERO_CONTENT') {
      obj = { 
        heroContent: data ,
        isWebinar : isWebinar || false,
        duration : duration || null,
        webinarTitle :webinarTitle || null
      }

      // setisWebinar(isWebinar);
    }
    if (currentEditSection === 'FOOTER_CONTENT') {
      obj = { footerContent: data }
    }

    
   

    setViewEditor(false)
    dispatchLayout(obj);
    // dispatchEmailLayout(obj);
  }

  const handleCloseUploader = (data,width,height) => {
    // console.log(width,height);
    if (data) {
      
      let obj = {}
      if (currentEditSection === 'HEADER_LOGO') {
        obj = { headerLogo: { url: data.Location , 
                              width : width ||  '420px', 
                              height : height || null} 
              }
      }
      if(currentEditSection === 'CONTENT_LOGO'){
        obj = {contentLogoUrl : { url: data.Location , 
          width : width ||  '120px', 
          height : height || null}}
      }
      if (currentEditSection === 'HERO_IMAGE') {
        obj = { heroImage: { url: data.Location , 
                            width : width || '360px' , 
                            height : height || null} 
              }
      }
      if (currentEditSection === 'FOOTER_LOGO') {
        obj = { footerLogo:{ url: data.Location , 
                              width : width || null , 
                              height :height || null} 
              }
      }
      dispatchLayout(obj);
      // dispatchEmailLayout(obj);
    }
    setViewUploader(false)
  }

  const handleCloseBuilder = (data) => {
    setViewFormBuilder(false);
    if (data && Object.keys(data).length > 0) {
      appendItem(data);
      dispatchFields(data)
    }
  }


  const handleCloseLayoutChanger = (data) => {
    // console.log(data);
    let obj = {}
    if (data) {
      if (currentEditSection === 'TITLE') {
        obj = {
          title: {
            text: data.text,
            backgroundColor: data.backgroundColor,
            textColor: data.textColor,
            subtitle : data.subtitle
          }
        }
      }
      if (currentEditSection === 'ADDITIONAL_TITLE') {
        obj = {
          additionalTitle: {
            text: data.text,
            backgroundColor: data.backgroundColor,
            textColor: data.textColor,
            subtitle : data.subtitle
          }
        }
      }
      if (currentEditSection === 'ACTION_BTN') {
        obj = {
          actionButton: {
            text: data.text,
            backgroundColor: data.backgroundColor,
            textColor: data.textColor,
            link: data.link
          }
        }
      }
      if (currentEditSection === 'FORM_TITLE') {
        obj = {
          formTitle: {
            text: data.text,
            backgroundColor: data.backgroundColor,
            textColor: data.textColor,
            link: data.link
          }
        }
      }
      dispatchLayout(obj)
      // dispatchEmailLayout(obj);

    }
    setViewLayoutChanger(false)
  }


  const getAddRemove = (i) => {
    return (
      <>
        <FaCircleMinus onClick={(() => handleRemove(i))} className='mt-3' style={{ color: "red" , cursor :'default'}} />
        {(itemFields.length - 1) === i && <FaCirclePlus onClick={(() => handleAdd())} className='mt-3 ml-2' style={{ color: "green" , cursor :'default' }} />}

      </>
    )
  }

  const getField = (item, i) => {
    return (
      <>
        {/* type check */}
         {item.type !== 'check' &&
          (url.includes('preview'))&&
            <div style={{paddingLeft:'51px'}}>
            <label className='field-trendline-label'>{item?.label}</label>
            </div>
         }
       
       {item.type !== 'check' &&
          (url.includes('create-lp') || url.includes('edit-lp') || url.includes('view-lp')  )&&
            <div style={{paddingLeft:'45px'}}>
            <label className='field-trendline-label'>{item?.label}</label>
            </div>
         }

         {/* type email */}
  {
  item.type === 'email' &&
  <span className="field">
    <div
      className="flex justify-content-center"
      style={{ height: "45px", marginTop: "5px" }}
    >
      <Controller
        name={item.name}
        control={control}
        rules={{
          required: item.message,
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Please enter a valid email address"
          }
        }}
        render={({ field, fieldState }) => (
          <>
            <span className="w-336">
              <InputText
                id={field.name}
                value={field.value}
                type="email"
                className={classNames({ 'p-invalid': fieldState.error })}
                onChange={(e) => field.onChange(e.target.value)}
              />
            </span>
          </>
        )}
      />
      <div className={`${itemFields.length - 1 === i && editMode ? 'ml-2' : 'ml-5'}`}>
        {editMode && <div>{getAddRemove(i)}</div>}
      </div>
    </div>

    <span>{getFormErrorMessage(item.name)}</span>
  </span>
}
    {/* type text */}
        {
          item.type === 'text' &&
          <span className='field'>
            <div className="flex justify-content-center" style={{ height: "45px" , marginTop : '3px'  }}>
              <Controller
                name={item.name}
                control={control}
                rules={{ required: item.message }}
                render={({ field, fieldState }) => (

                  <>
                     <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label> 
                    <span className='w-336'>
                      <InputText id={field.name}  value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                     {/* <label htmlFor={field.name}>{item.label}*</label> */}
                    </span>
                  </>
                )}
              />
              <div className={`${itemFields.length - 1 === i && editMode ? 'ml-2' : 'ml-5'}`}>
                {editMode && <div >{getAddRemove(i)}</div>}
              </div>
            </div>
            <span>{getFormErrorMessage(item.name)}</span>
          </span>

        }

      
        {
          item.type === 'select' &&
          <span className='field dropdown-field'>
            <div className="flex justify-content-center" key={item.id}>
              <Controller
                style={{ width: "277px", }}
                name={item.name}
                control={control}
                rules={{ required: item.message }}
                render={({ field, fieldState }) => (
                  <>
                      <Dropdown
                        style={{width : '450px'}}
                        id={field.name}
                        value={field.value}
                        optionLabel="label"
                        // placeholder={item.label}
                        options={item.options}
                        focusInputRef={field.ref}
                        onChange={(e) => field.onChange(e.value)}
                        className={classNames({ 'p-invalid': fieldState.error })}
                      />
                  </>

                )}
              />

              <div className={`${itemFields.length - 1 === i && editMode ? 'ml-2' : 'ml-5'}`}>
                {editMode && <div>{getAddRemove(i)}</div>}
              </div>
            </div>
            <span>{getFormErrorMessage(item.name)}</span>
          </span>
        }
        {
          item.type === 'number' &&
          <span className='field'>
            <div className="flex justify-content-center" style={{ height: "45px" , marginTop : '3px'  }} >
              <Controller
                name={item.name}
                control={control}
                rules={{ required: item.message }}
                render={({ field, fieldState }) => (
                  <>
                    <label htmlFor={field.name}  className={classNames({ 'p-error': errors.value })}></label>
                    <span className='w-336'>
                      <InputText keyfilter="int" id={field.name} value={field.value}  className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                      {/* <label htmlFor={field.name}>{item.label}*</label> */}
                    </span>
                  </>
                )}
              />
              <div className={`${itemFields.length - 1 === i && editMode ? 'ml-2' : 'ml-5'}`}>
                {editMode && <div>{getAddRemove(i)}</div>}
              </div>
            </div>
            <span>{getFormErrorMessage(item.name)}</span>
          </span>
        }
        {
          item.type === 'check' &&
          <span className='field'>
            <div className="flex justify-content-center" style={{ width: "100%" , height: "auto" , marginTop : '3px' }}>
              <Controller
                name={item.name}
                control={control}
                rules={{ required: item.message }}
                render={({ field, fieldState }) => (
                  <>
                    <label htmlFor={field.name} className={classNames({ 'p-error': errors.checked })}></label>
                    <Checkbox inputId={field.name} checked={field.value} inputRef={field.ref} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.checked)} />
                  </>
                )}
              />
              <label htmlFor="ingredient1" className="ml-2 opt-in"><MarkupViewer htmlString={item.label}></MarkupViewer></label>
              <div className={`${itemFields.length - 1 === i  && editMode ? 'ml-2' : 'ml-5'}`}>
                {editMode && <div className='check'>{getAddRemove(i)}</div>}
              </div>
            </div>
            <span>{getFormErrorMessage(item.name)}</span>
          </span>
        }
      </>

    )
  }






  return (
    <>
      <Toast ref={toast}></Toast>
      {/* <div>
      <p>Current URL: {url}</p>
    </div> */}
   {url.includes('preview') && <div>
      <div className="row  box-shadows d-flex justify-content-center header-settings">
        <div className="col-md-12 col-sm-12  d-flex justify-content-center">
        <img className="headerLogo" style={{width : layout?.headerLogo?.width || '420px' , height : layout?.headerLogo?.height || 'auto'}} src={layout?.headerLogo?.url} alt="Header logo" />
        </div>
    </div>
      <div className='mt-7'>
   

    <div className='header-settings-1'>
        <div className="row mt-5 justify-content-center" style={{width : '100%'}} >
           
                <h3 className="trendline mt-5">TRENDLINE</h3>
            
            
        </div>
        <div className="row justify-content-center" style={{}}>
      
        <div className="heading">
              <h4 className="headerTitle" style={{ color: layout?.title?.textColor || 'black' , paddingBottom : (layout?.title?.subtitle && layout?.title?.subtitle !== '') ? '0px' : '40px' , paddingTop : '0px'}}>{layout?.title?.text} </h4>
              {layout?.title?.subtitle ? (
                <p className="headerSubTitle" style={{ color: layout?.title?.textColor || 'black' }}>{layout?.title?.subtitle}</p>            
            ) : ('')}
                 {/* <p className="headerSubTitle" style={{ color: layout?.title?.textColor || 'white' }}>{layout?.title?.subtitle}</p>             */}
             
            
            </div>
          
        </div>
        <div className="row  justify-content-center" style={{alignItems : 'center'}}>
            
                <span style={{fontSize: "17px", marginRight: '10px'}}>Supported by</span>
                <img className="headerLogo img-size" style={{width : layout?.contentLogoUrl?.width || '120px' , height : layout?.contentLogoUrl?.height || 'auto'}} src={layout?.contentLogoUrl?.url} alt="Header logo" />
           
        </div>

        <div class="row" style={{justifyContent : 'center'}}>
                <div className="col-md-12 d-flex justify-content-center mt-5" style={{display : 'flex'}}>
                <img className="simg bg-img" style={{width : layout?.heroImage?.width || '360px' , height : layout?.heroImage?.height || 'auto'}} src={layout?.heroImage?.url} alt="Hero Image" />
                </div>
            </div>

      </div>

      <div>

      <div className="MainRow" style={{backgroundColor: '',paddingTop:'30px'}}>
        <div className='row justify-content-center'>

      <div style={{width:'100%'}} className='row content-des-div'>
        <div style={{width : '50%'}}>

            <div className="mt-4">
                <div className="d-flex justify-content-start">
              
                <div className="heading1">
              <h5 className="headerTitle" style={{ color: layout?.additionalTitle?.textColor || 'black' , paddingBottom : (layout?.additionalTitle?.subtitle && layout?.additionalTitle?.subtitle !== '') ? '0px' : '5px' }}>{layout?.additionalTitle?.text} </h5>
              {layout?.additionalTitle?.subtitle ? (
                <p className="headerSubTitle" style={{ color: layout?.additionalTitle?.textColor || 'black' }}>{layout?.additionalTitle?.subtitle}</p>            
            ) : ('')}
                 {/* <p className="headerSubTitle" style={{ color: layout?.title?.textColor || 'white' }}>{layout?.title?.subtitle}</p>             */}
             
            
            
            
            </div>
            <div style={{fontSize : "16px"}} className={`md:col-offset-1 md:col-10 col-12 text-left description ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('HERO_CONTENT')) : undefined}>
            <MarkupViewer htmlString={layout?.heroContent} ></MarkupViewer>
          </div>
                </div>
            </div>

       

         

        
        </div>
        <div style={{width : '50%' ,background: '#d6d3d326'}}>
          <div style={{display:'flex',justifyContent : 'center', marginTop : '30px'}}>

        <img className="headerLogo" style={{width:'210px'}} src={layout?.contentLogoUrl?.url} alt="Header logo" />
          </div>

          <div style={{backgroundColor: layout?.formTitle?.backgroundColor , padding : '0' , margin : '0'}}>

            <h4 style={{textAlign : 'center',fontWeight : '400' , padding : '12px'}}> <span className={` ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('FORM_TITLE')) : undefined} style={{ color: layout?.formTitle?.textColor }}>{layout?.formTitle?.text}</span>
              {itemFields.length === 0 && editMode && <FaCirclePlus onClick={handleAdd} className='mt-3' style={{ color: "green" }} />}</h4>
          </div>
            <div className='row' style={{justifyContent : 'center'}}>
            <form onSubmit={handleSubmit(onFormSubmit)} style={{width:'35rem' , marginLeft: '1rem'}}>
              {
                itemFields &&
                itemFields.map((item, index) => <div key={item.id}> {getField(item, index)}</div>)
              }
              <div className={`flex justify-content-center ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('ACTION_BTN')) : undefined}>
                <Button label={layout?.actionButton?.text} style={{ backgroundColor: layout?.actionButton?.backgroundColor || "#087d95", color: layout?.actionButton?.textColor || 'white' , marginBottom : '40px' , width : '450px' , borderRadius : '5px'}} type="submit" outlined />
              </div>
            </form>
            </div>
          </div>

    </div>
        </div>
          
    <div className='row' style={{paddingTop: '40px',zIndex: '10000' , background : 'white'}}>

<div className={`col-12  text-center ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('FOOTER_CONTENT')) : undefined}>
            <MarkupViewer htmlString={layout?.footerContent}></MarkupViewer>
          </div>
 </div>
      </div>
      </div>
     
    
    </div> 
   
    </div>}
  
    {(url.includes('create-lp') || url.includes('edit-lp') || url.includes('view-lp')) && <div>
      <div className="row  box-shadows d-flex justify-content-center">
        <div className={`col-md-12 col-sm-12  d-flex justify-content-center ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('HEADER_LOGO')) : undefined}>
        <img className="headerLogo" style={{width : layout?.headerLogo?.width || '420px' , height : layout?.headerLogo?.height || 'auto'}} src={layout?.headerLogo?.url} alt="Header logo" />
        </div>
    </div>
      <div className='mt-7'>
   

    <div className=''>
        <div className="row mt-5 justify-content-center" style={{width : '100%'}} >
           
                <h3 className="trendline mt-5">TRENDLINE</h3>
            
            
        </div>
        <div className="row justify-content-center" style={{}}>
      
        <div className="heading">
              <h4 className={`headerTitle ${editMode ? "u-hover--sparkle" : ""}`}  onClick={editMode ? (() => handleClick('TITLE')) : undefined} style={{ color: layout?.title?.textColor || 'black' , paddingBottom : (layout?.title?.subtitle && layout?.title?.subtitle !== '') ? '0px' : '40px' , paddingTop : '0px'}}>{layout?.title?.text} </h4>
              {layout?.title?.subtitle ? (
                <p className="headerSubTitle" style={{ color: layout?.title?.textColor || 'black' }}>{layout?.title?.subtitle}</p>            
            ) : ('')}
                 {/* <p className="headerSubTitle" style={{ color: layout?.title?.textColor || 'white' }}>{layout?.title?.subtitle}</p>             */}
             
            
            </div>
          
        </div>
        <div className={`row  justify-content-center ${editMode ? "u-hover--sparkle" : ""} ` } style={{alignItems : 'center'}} onClick={editMode ? (() => handleClick('CONTENT_LOGO')) : undefined} >
            
                <span style={{fontSize: "17px", marginRight: '10px'}}>Supported by</span>
                <img className={`headerLogo img-size`} style={{width : layout?.contentLogoUrl?.width || '120px' , height : layout?.contentLogoUrl?.height || 'auto'}} src={layout?.contentLogoUrl?.url} alt="Header logo" />
           
        </div>

        <div class="row" style={{justifyContent : 'center'}}>
                <div style={{display : 'flex'}} className={`col-md-12 d-flex justify-content-center mt-5 ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('HERO_IMAGE')) : undefined}>
                <img className="simg" style={{width : layout?.heroImage?.width || '360px' , height : layout?.heroImage?.height || 'auto'}} src={layout?.heroImage?.url} alt="Hero Image" />
                </div>
            </div>

      </div>

      
      <div className="MainRow" style={{marginTop:'0px',backgroundColor: '',paddingTop:'30px'}}>
        <div className='row  justify-content-center'>
      <div style={{width:'100%', zIndex : 'unset'}} className='row content-des-div'>
        <div style={{width : '50%'}}>

            <div className="mt-4">
                <div className="d-flex justify-content-start">
              
                <div className={`heading1 ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('ADDITIONAL_TITLE')) : undefined}>
              <h5 className="headerTitle" style={{ color: layout?.additionalTitle?.textColor || 'black' , paddingBottom : (layout?.additionalTitle?.subtitle && layout?.additionalTitle?.subtitle !== '') ? '0px' : '5px' }}>{layout?.additionalTitle?.text} </h5>
              {layout?.additionalTitle?.subtitle ? (
                <p className="headerSubTitle" style={{ color: layout?.additionalTitle?.textColor || 'black' }}>{layout?.additionalTitle?.subtitle}</p>            
            ) : ('')}
                 {/* <p className="headerSubTitle" style={{ color: layout?.title?.textColor || 'white' }}>{layout?.title?.subtitle}</p>             */}
             
            
            
            
            </div>
            <div style={{fontSize : "16px"}} className={`md:col-offset-1 md:col-10 col-12 text-left description ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('HERO_CONTENT')) : undefined}>
            <MarkupViewer htmlString={layout?.heroContent} ></MarkupViewer>
          </div>
                </div>
            </div>

       

         

        
        </div>
        <div style={{width : '50%' ,background: '#d6d3d326'}}>
          <div style={{display:'flex',justifyContent : 'center', marginTop : '30px'}}>
        <img className="headerLogo" style={{width : '210px' , height : layout?.contentLogoUrl?.height || 'auto'}} src={layout?.contentLogoUrl?.url} alt="Header logo" />
          </div>
          <div style={{ color: layout?.formTitle?.textColor , backgroundColor: layout?.formTitle?.backgroundColor , padding : '0' , margin: '0' }}>
            <h4 style={{textAlign : 'center',fontWeight : '400'}}> <span className={` ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('FORM_TITLE')) : undefined} style={{ color: layout?.formTitle?.textColor  , padding : '12px' }}>{layout?.formTitle?.text}</span>
              {itemFields.length === 0 && editMode && <FaCirclePlus onClick={handleAdd} className='mt-3' style={{ color: "green" }} />}</h4>
          </div>
            
            <div className='row' style={{justifyContent : 'center'}}>
            <form onSubmit={handleSubmit(onFormSubmit)} style={{width:'35rem' , marginLeft: '1rem'}}>
            {(url.includes('view-lp')) &&
              <div>
              {
                itemFields &&
                itemFields.map((item, index) => <div key={item.id}> {getField(item, index)}</div >)
              }
              </div>
              }

              {(url.includes('create-lp') || url.includes('edit-lp')) &&
              <DragDropContext onDragEnd={handleDragEnd}>
                      <Droppable droppableId="list">
                          {(provided) => (
                              <div className="custom-cursor" {...provided.droppableProps} ref={provided.innerRef}>
                                  {itemFields.map((item, index) => (
                                      <Draggable style={{cursor : 'move'}} key={item.id} draggableId={item.id} index={index}>
                                          {(provided) => (
                                              <div  ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                              
                                              {/* {item.type !== 'check' &&
                                            <div>
                                            <label className='field-label'>{item?.label}</label>
                                        </div>
                                              }  */}
                                                  <div>{getField(item, index)}</div>
                                              </div>
                                          )}
                                      </Draggable>
                                  ))}
                                  {provided.placeholder}
                              </div>
                          )}
                      </Droppable>
                  </DragDropContext>
              }
              <div className={`flex justify-content-center ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('ACTION_BTN')) : undefined}>
                <Button label={layout?.actionButton?.text} style={{ backgroundColor: layout?.actionButton?.backgroundColor || "#087d95", color: layout?.actionButton?.textColor || 'white' , marginBottom: '40px' , width : '450px' , borderRadius : '5px'}} type="submit" outlined />
              </div>
            </form>
            </div>
          </div>
    </div>

        </div>
 <div className='row' style={{paddingTop: '40px',zIndex: '10000' , background : 'white'}}>

<div className={`col-12  text-center ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('FOOTER_CONTENT')) : undefined}>
            <MarkupViewer htmlString={layout?.footerContent}></MarkupViewer>
          </div>
 </div>
      </div>
       
    </div> 
    </div>}

   
    

     
    
      
      {/* <div className={`grid ${editMode ? "u-hover--sparkle" : ""}`} style={{marginTop: '600px', marginBottom: '20px'}} onClick={editMode ? (() => handleClick('FOOTER_CONTENT')) : undefined}>
        
        </div> */}
      {viewUploader && <FileUploader open={viewUploader} handleCloseUploader={handleCloseUploader}></FileUploader>}
      {viewEditor && <MarkupChanger open={viewEditor} text={markup}    isWebinarEnabled = {layout.isWebinar}
          webinarTitleVal = {layout.webinarTitle}
          durationVal = {layout.duration} handleCloseEditor={handleCloseEditor}></MarkupChanger>}
      {viewFormBuilder && <FormBuilder open={viewFormBuilder} data={markup} handleCloseBuilder={handleCloseBuilder}></FormBuilder>}
      {viewLayoutChanger && <LayoutChanger open={viewLayoutChanger} data={content} handleCloseLayoutChanger={handleCloseLayoutChanger}></LayoutChanger>}

    </>

  )
}

export default TrendLineTemplate